import { Job } from "@models/job.model";
import { JobService } from "@services/jobs/jobService";
import { useEffect, useState } from "react";

export default function useJobDetail(jobId: number) {
    const [job, setJob] = useState<Job | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    async function loadJob() {
        setIsLoading(true)
        const service = new JobService()
        setJob(await service.getJob(jobId));
        setIsLoading(false)
    }

    useEffect(() => {
        loadJob()
    }, [])

    return {
        job,
        isLoading,
        reload: loadJob,
    }
}